import { cn } from '@/lib/cn';

type Variant = 'card' | 'row' | 'chart' | 'text';

const VARIANT_CLASSES: Record<Variant, string> = {
  card: 'h-24 w-full',
  row: 'h-8 w-full',
  chart: 'h-56 w-full',
  text: 'h-4 w-32',
};

export function LoadingSkeleton({
  variant = 'card',
  className,
}: {
  variant?: Variant;
  className?: string;
}) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label="Loading"
      className={cn(
        'animate-pulse rounded-md bg-zinc-900/60',
        VARIANT_CLASSES[variant],
        className,
      )}
    />
  );
}
